import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import MenuSection from "./components/MenuSection";
import OrderSection from "./components/OrderSection";
import AboutSection from "./components/AboutSection";
import GallerySection from "./components/GallerySection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import Bestellung from "./components/Bestellung";
import SplashScreen from "./components/SplashScreen";
import WoltOrderButton from "./components/WoltOrderButton";
import GoogleRatingBadge from "./components/GoogleRatingBadge";

const HomePage = () => {
  const location = useLocation();
  const scrollTarget = location.state && location.state.scrollTo;
  // Skip splash when arriving with a scroll target (coming from another page)
  const [showSplash, setShowSplash] = React.useState(!scrollTarget);

  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  React.useEffect(() => {
    if (!scrollTarget) return;
    const scrollNow = () => {
      const el = document.getElementById(scrollTarget);
      if (el) {
        const offsetPosition = el.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: offsetPosition, behavior: "smooth" });
      }
    };
    // wait for sections/images to lay out
    const timer = setTimeout(scrollNow, 300);
    window.history.replaceState({}, document.title);
    return () => clearTimeout(timer);
  }, [scrollTarget]);

  return (
    <>
      {showSplash && <SplashScreen onComplete={handleSplashComplete} />}
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <GallerySection />
        <ContactSection />
      </main>
      <Footer />
      <WoltOrderButton />
      <GoogleRatingBadge />
    </>
  );
};

const SpeisekartePage = () => {
  return (
    <>
      <Header />
      <main>
        <MenuSection />
      </main>
      <Footer />
    </>
  );
};

const BestellungPage = () => {
  return (
    <>
      <Header />
      <main>
        <OrderSection />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-black min-h-screen">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/speisekarte" element={<SpeisekartePage />} />
            <Route path="/bestellung" element={<BestellungPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
